export class ClaimOrderPositionModel {
    constructor(orderPositionId: string) {
        this.orderPositionId = orderPositionId;
    }

    orderPositionId: string;
}